export const StatusBarType = {
    DANGER: 'danger',
    WHITE: 'white',
};
